import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import App from "./Components/Home";
import LLMPage from "./Components/LLM/LLMPage";
import StartupPitch from "./Components/Startup/Home";
import "./styles.css";


const Root = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/LLMPage" element={<LLMPage />} />
        <Route path="/StartupPitch" element={<StartupPitch />} />
      </Routes>
    </Router>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Root />);
